import type { ReactNode } from 'react';
import { PageBody, PageHeader } from '../../app/AppLayout';
import { BlockedState } from '../../components/PageStates';
import { isSuperAdmin, useCurrentStaff } from '../../auth/session';

/**
 * CRM hội sở chỉ Super Admin (ADR-005): khách không thuộc chi nhánh nào, nên danh sách này
 * không lọc được theo BR-801. Mở cho quản lý chi nhánh là mở toàn bộ danh bạ khách.
 */
export function SuperAdminGate({ title, children }: { title: string; children: ReactNode }) {
  const staff = useCurrentStaff();
  if (isSuperAdmin(staff)) return children;

  return (
    <>
      <PageHeader title={title} />
      <PageBody>
        <BlockedState message="Danh sách thành viên chỉ Super Admin được mở. Khách không thuộc chi nhánh nào nên không lọc được theo cửa hàng." />
      </PageBody>
    </>
  );
}
